export default "* Tag udgangspunkt i spørgsmål fra dialogkortene, der knytter sig til historiens forskellige kapitler. ";